import React, { useEffect, useRef, useState } from 'react'

import { Chip, Stack, Tooltip } from '@mui/material'

import { fitProposedFieldLabels, PROPOSED_FIELD_SEPARATOR } from 'utils/data-change-requests'

const CHIP_WIDTH = 44

let context: CanvasRenderingContext2D | null | undefined

const textMeasurer = (font: string) => {
  if (context === undefined) {
    try {
      context = document.createElement('canvas').getContext('2d')
    } catch {
      context = null
    }
  }
  if (!context) return null

  const measuring = context
  measuring.font = font
  return (text: string) => measuring.measureText(text).width
}

const ProposedChanges = ({ labels }: { labels: string[] }) => {
  const ref = useRef<HTMLDivElement>(null)
  const [box, setBox] = useState({ width: 0, font: '' })

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const read = () => setBox({ width: element.clientWidth, font: window.getComputedStyle(element).font })

    read()
    if (typeof ResizeObserver === 'undefined') return

    const observer = new ResizeObserver(read)
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  // No measurement (jsdom, zero-width cell) means we cannot tell what fits, so hide nothing.
  const measure = box.width ? textMeasurer(box.font) : null
  const visible = measure ? fitProposedFieldLabels(labels, box.width, measure, CHIP_WIDTH) : labels.length
  const rest = labels.slice(visible)

  return (
    <Stack direction="row" ref={ref} spacing={0.5} sx={{ alignItems: 'center', minWidth: 0 }}>
      {/* minWidth 0: a flex item's automatic minimum is its min-content, and nowrap text would prop the column open. */}
      <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {labels.slice(0, visible).join(PROPOSED_FIELD_SEPARATOR)}
      </span>
      {!!rest.length && (
        <Tooltip title={rest.join(PROPOSED_FIELD_SEPARATOR)}>
          <Chip label={`+${rest.length}`} size="small" variant="outlined" />
        </Tooltip>
      )}
    </Stack>
  )
}

export default ProposedChanges
